import React from "react";
import ServiceOfferingsContent from "../function-components/ServiceOfferingsContent";

function ServiceOfferings() {
  return (
    <>
      <ServiceOfferingsContent />
    </>
  );
}

export default ServiceOfferings;
